import React from 'react';
import PropTypes from 'prop-types';
import { toSimpleDateString } from 'src/utils/format/date';
import s from './ActivitiesGrid.styles';

const ActivitiesGridItem = ({ item }) => {
  return (
    <s.NoLink withoutDelete>
      <s.Item>{toSimpleDateString(item.createdAt)}</s.Item>
      <s.Item capitalize>{item.action}</s.Item>
      <s.Item>{item.userName}</s.Item>
    </s.NoLink>
  );
};

ActivitiesGridItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    createdAt: PropTypes.string,
    action: PropTypes.string,
    userName: PropTypes.string,
  }).isRequired,
};

export default React.memo(ActivitiesGridItem);
